module.exports = __webpack_public_path__ + "static/neste_side_Kris_norsk_text-3b9e3b615d4774ff86cc12e9c04d8884.png";